module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/surveys/new-survey/mail-list-tab/mail-list-tab.component.less
// module id = ./src/app/routes/surveys/new-survey/mail-list-tab/mail-list-tab.component.less
// module chunks = main